"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _permissionTestUtils = require("./permissionTestUtils");
Object.keys(_permissionTestUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _permissionTestUtils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _permissionTestUtils[key];
    }
  });
});
var _PermissionController = require("./PermissionController");
Object.keys(_PermissionController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PermissionController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PermissionController[key];
    }
  });
});